import { render, staticRenderFns } from "./PostCover.vue?vue&type=template&id=0f590026&scoped=true&"
import script from "./PostCover.vue?vue&type=script&lang=js&"
export * from "./PostCover.vue?vue&type=script&lang=js&"
import style0 from "./PostCover.vue?vue&type=style&index=0&id=0f590026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f590026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VLayout})
